import { IcClose } from '@assets/icons/24x24';
import { Box, HStack, Icon, IconButton, SystemStyleObject, useSlotRecipe } from '@chakra-ui/react';
import { useDragControlsContext } from '@components/ui/draggable/DraggableBox';
import { DraggablePanelHeaderProps, DraggablePanelVariantProps } from '@components/ui/draggable/DraggablePanel';
import { forwardRef, PointerEvent } from 'react';

export const Header = forwardRef<HTMLDivElement, DraggablePanelHeaderProps & DraggablePanelVariantProps>(
  ({ onClose, children }, ref) => {
    const { dragControls, isDragging } = useDragControlsContext();
    const { header, title } = useSlotRecipe({ key: 'draggablePanel' })();
    const handlePointerDown = (event: PointerEvent<HTMLDivElement>) => {
      dragControls.start(event);
    };

    return (
      <Box ref={ref} {...header}>
        <HStack
          {...(title as Omit<SystemStyleObject, 'direction'>)}
          cursor={isDragging ? 'grabbing' : 'grab'}
          onPointerDown={handlePointerDown}
        >
          {children}
          {onClose && (
            <IconButton variant="transparent" marginLeft="auto" padding="tightL" onClick={onClose}>
              <Icon as={IcClose} boxSize="24px" onClick={onClose} />
            </IconButton>
          )}
        </HStack>
      </Box>
    );
  },
);
